import React from "react";

/**
 * Reusable Fingerprint Loading Modal
 * @param {boolean} open - show / hide modal
 * @param {string} step - current RD service step text
 */
const FingerprintModal = ({ open, step }) => {
  if (!open) return null;

  return (
    <div className="fp-backdrop">
      <div className="fp-modal">
        <div className="finger-scan">
          <span></span>
        </div>

        <h3 className="fp-title">Biometric Authentication</h3>

        <p className="fp-step">
          {step || "Please place your finger on the scanner"}
        </p>

        <p className="fp-hint">
          Do not remove finger until process completes
        </p>
      </div>
    </div>
  );
};

export default FingerprintModal;
